import React from "react";

const ThreeDotLoader = () => {
  return (
    <span id="three-dot-loading">
      <span>•</span>
      <span>•</span>
      <span>•</span>
      {/* <span>.</span>
      <span>.</span>
      <span>.</span> */}
    </span>
  );
};

export default ThreeDotLoader;
